import apiService from 'src/enviroment';

// Lista de solicitudes para crear un reporte
const getRequestReport = async () => {
  try {
    const response = await apiService.get(
      '/admin/datastudio/solicitud/reporte/',
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

// Crear solicitud reporte
const postRequestReport = async (params) => {
  try {
    const { status, data } = await apiService.post(
      '/admin/datastudio/solicitud/reporte/',
      params,
    );
    if (status === 200 && data.success === 1) {
      return data;
    }
    return false;
  } catch (error) {
    return false;
  }
};

// rechazarSolicitud de reporte
const putRejectReportRequest = async (params) => {
  try {
    const response = await apiService.put(
      '/admin/datastudio/solicitud/reporte/',
      params,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const deleteUser = async (id) => {
  try {
    const response = await apiService.delete(
      `/admin/usuarios_inventarios/?id=${id}`,
    );
    if (response.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    return false;
  }
};

const deleteRequest = async (id) => {
  try {
    const response = await apiService.delete(`/admin/datastudio/solicitud/reporte/?id=${id}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

const reportRequestService = {
  getRequestReport,
  postRequestReport,
  putRejectReportRequest,
  deleteUser,
  deleteRequest,
};

export default reportRequestService;
